<template>
  <div class="switchStyle" :style="styles" v-if="true">
    <!-- <div class="btn" @click="showCustomWorksPopup">我要定制一个</div> -->
    <div @click="switchStyleFs()">切换风格，获取更多素材</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Analysis from "../../../mixins/analysis/materialBu";

export default {
  mixins: [Analysis],
  props: {
    styles: Object,
    default() {
      return {};
    }
  },
  data() {
    return {
      judgebox: true
    };
  },
  computed: {
    ...mapGetters([
      "TopNav_Size",
      "Window_Size",
      "SelectScenes_Msg"
    ])
  },
  mounted() {
    // let touchMsgBoxData= this.$util.localStorage.get('MESSAGE-APP-data');
    // if(touchMsgBoxData && touchMsgBoxData.switchStyleBox){
    //   this.judgebox = false;
    // }
    // this.$bus.on('SwitchStyleTip', data => {
    //   if(data.styleType){
    //     this.judgebox = false;
    //   }
    // });
  },
  methods: {
    switchStyleFs() {
      this.$bus.emit("SwitchStyleTip", { data: true, styleType: true });
      let touchMsgBoxData = this.$util.localStorage.get("MESSAGE-APP-data");
      touchMsgBoxData.switchStyleBox = true;
      this.$util.localStorage.set("MESSAGE-APP-data", touchMsgBoxData);
      this.judgebox = false;

      // this.$store.commit("open_TemplateMaterialLibDialogMsg", {
      //   materialType: "scene"
      // });
    },
    showCustomWorksPopup() {
      this.$bus.emit("createCustomWorks");
      this.$modal.show("customWorks");
    }
  },
  components: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.switchStyle {
  width: 270px;
  border-radius: 8px;
  padding: 50px 0 50px;
  color: #7d97ff;
  text-decoration: underline;
  & > div {
    cursor: pointer;
  }
}
.btn {
  width: 160px;
  height: 40px;
  line-height: 40px;
  background-color: #5778fb;
  border-radius: 4px;
  color: #fff;
  margin: auto;
  margin-bottom: 16px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/rightnav/slide/search/switchStyle.vue